<!--赖传峰-->
<!--2022/4/30-->
<template>
  <div
    ref="mediaFileCover"
    :class="showIconLink && 'icon-link'"
    class="file-cover"
  >
    <div
      :style="thumbnailBlurStyle"
      class="blur"
    />
    <ElImage
      :alt="name"
      :class="showIconLink && load && 'icon-link'"
      :lazy="lazy"
      :src="imgSrc"
      fit="contain"
      @load="handleLoad"
      @error="handleError"
    >
      <template #placeholder>
        <div class="placeholder" />
      </template>
      <template #error>
        <div :class="isVideoInternal ? 'empty': 'error'" />
      </template>
    </ElImage>
    <!--阻止图片被拖拽，影响滑动选中功能-->
    <div
      v-if="load"
      class="disable-drag"
    />
  </div>
</template>

<script
  lang="ts"
  setup
>
import {
  computed,
  ref,
} from '#imports'
import { isVideo } from '@/utils'

const mediaFileCover = ref<HTMLElement>()
const load = ref<boolean>(false) // 缩略图是否加载完成

const emits = defineEmits<{
  load: [width: number, height: number]
}>()

const {
  thumbnailLink,
  lazy = true,
  iconLink,
  fileExtension,
  mimeType,
} = defineProps<{
  thumbnailLink?: string
  name: string
  iconLink: string
  fileExtension: string
  mimeType: string
  lazy?: boolean
}>()

const isVideoInternal = computed(() => isVideo(fileExtension, mimeType))

const imgSrc = computed(() => {
  if (isVideoInternal.value) return thumbnailLink
  return thumbnailLink || iconLink
})

const showIconLink = computed(() => !isVideoInternal.value && !thumbnailLink)

const thumbnailBlurStyle = computed(() => (
  load.value && thumbnailLink
    ? {
      'background-image': `url(${thumbnailLink})`,
      'background-color': '#fff',
      filter: 'blur(15px)',
    }
    : undefined
))

const handleLoad = (ev: Event) => {
  load.value = true
  if (ev.target) {
    emits('load', (ev.target as HTMLImageElement).naturalWidth, (ev.target as HTMLImageElement).naturalHeight)
  }
}

const handleError = () => {
  if (isVideoInternal.value) {
    emits('load', 0, 0)
  }
}

</script>

<style lang="less">
.file-cover {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .blur {
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
  }

  @status: {
    placeholder: #e1e6ea;
    empty: #323233;
    error: #e1e6ea;
  }

  each(@status, {
    .@{key} {
      @url: '@/assets/images/share/thumbnail-@{key}.svg';

      height: 100%;
      background: url(@url) var(--no-repeat-center) / var(--error-placeholder-image-size), @value;
    }
  })

  .disable-drag {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .el-image {
    width: 100%;
    height: 100%;
  }

  .icon-link {
    width: var(--icon-link-size);
    height: var(--icon-link-size);
  }
}
</style>
